import React, { useState, useEffect } from 'react';
import './Footer.css';

const Footer = () => {
  const [visitorCount, setVisitorCount] = useState(null);

  useEffect(() => {
    // Get visitor count from localStorage
    let count = localStorage.getItem('visitorCount');
    
    if (!count) {
      // First time visitor - start at a random number (looks more authentic)
      count = Math.floor(1000 + Math.random());
    } else {
      count = parseInt(count);
    }
    
    // Increment the count
    count++;
    
    // Save back to localStorage
    localStorage.setItem('visitorCount', count);
    
    // Set state
    setVisitorCount(count);
  }, []);

  return (
    <footer className="retro-footer">
      <div className="footer-garden">
        <div className="footer-mushroom small"></div>
        <div className="footer-mushroom"></div>
        <div className="footer-mushroom small"></div>
        <div className="footer-mushroom"></div>
        <div className="footer-mushroom small"></div>
      </div>
      <div className="footer-content">
        <div className="footer-text">
          <div className="footer-text large">THANKS FOR VISITING!</div>
          Last updated: December 2025 <br />
          {visitorCount !== null && `Visitor count: ${visitorCount.toString().padStart(6, '0')}`}        </div>
        <div className="footer-decorations">
          <div className="footer-leaf"></div>
          <div className="footer-flower-small"></div>
          <div className="footer-leaf"></div>
          <div className="footer-flower-small"></div>
          <div className="footer-leaf"></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;